import { optional, record, string, literal, union, empty, someRecord, unknown, } from "@discovery/prelude/lib/data/validated";
// TODO: add the error codes when used
const errorCodes = union(literal("server.error"), 
//
literal("apple.auth.failed"), 
// literal("access.denied.age.restricted"),
literal("restricted.route"), 
// literal("already.subscriber"),
// literal("access.denied"),
literal("campaign.code.already.used"), 
// literal("campaign.code.required"),
literal("campaign.code.not.valid"), literal("campaign.not.available"), literal("campaign.already.used"), literal("campaign.code.wrong.price.plan"), literal("campaign.is.only.for.new.customers"), literal("priceplan.closed"), 
// literal("priceplan.closed"),
// literal("concurrentstreams.exceeded"),
// literal("deviceid.missing"),
// literal("access.denied.geoblocked"),
literal("facebook.email.required"), literal("invalid.otp"), literal("invalid.parameter"), 
// literal("invalid.password"),
literal("invalid.payload"), literal("invalid.token"), 
// literal("access.denied.missingpackage"),
// literal("no.payment.method"),
// literal("priceplan.missing"),
literal("missing.resource"), literal("not.found"), 
// literal("access.denied.outside.playable.windows"),
literal("password.needs.reset"), 
// literal("payment.auth.failed"),
// literal("payment.cvc.declined"),
// literal("payment.expired.card"),
// literal("payment.transaction.not.permitted"),
// literal("payment.invalid.card.number"),
// literal("payment.not.enough.funds"),
// literal("payment.refused"),
// literal("payment.canceled"),
// literal("payment.unknown.error"),
// literal("payment.maximum.retries"),
// literal("payment.territory.mismatch"),
// literal("priceplan.closed"),
literal("toolbox.unauthorized"), literal("unauthorized"), literal("unauthorized.username.unknown"), 
// literal("username.exists"),
// literal("facebook.email.required"),
// literal("free.trial.already.used"),
// literal("home.territory.already.verified"),
// literal("price.plan.has.incorrect.market.id"),
// literal("campaign.is.only.for.new.customers"),
literal("invalid.code"), literal("code.expired"), 
// GCN token login specific
literal("conflict.1"), literal("conflict.2"), literal("conflict.3"), literal("conflict.4"), literal("conflict.6"));
const errorMeta = union(record({
    reason: string,
    redirectToRelativeUrlAction: record({
        relativeUrl: string,
    }),
}), record({
    reason: string,
    useRouteAction: record({
        route: string,
    }),
}), someRecord(unknown));
// TODO: move this to sonic-api-ng/src/api/common/resource instead?
const emptyMeta = empty();
const emptyData = empty();
const emptyError = empty();
const emptyRelationships = empty();
// TODO: move this to sonic-api-ng/src/api/common/resource instead?
// TODO: this needs to be updated as soon as sonic updates their docs.
// For now, code always exists
const someError = record({
    code: errorCodes,
    detail: optional(string),
    id: string,
    status: optional(string),
    title: optional(string),
    meta: optional(errorMeta),
});
export { emptyMeta, emptyData, emptyError, emptyRelationships, someError, };

